/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';

const TextInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({ ...props }, ref) => {
    return <input {...props} type="text" className="form-control" id={props.id ?? props.name} ref={ref} />;
});

export default TextInput;
